import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { FAQ } from "@/data/offer";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <Reveal className="lg:col-span-4">
          <Eyebrow>FAQ</Eyebrow>
          <h2 className="font-display mt-5 text-4xl font-medium leading-[1.02] tracking-[-0.02em] text-ink sm:text-5xl">
            Pytania, które padają najczęściej
          </h2>
          <p className="mt-5 max-w-[40ch] text-[15px] leading-relaxed text-ink/60">
            Jeżeli nie znajdziesz odpowiedzi, napisz:{" "}
            <a href="mailto:info@luizawojtowiczwaga.com" data-testid="faq-email-link" className="font-semibold text-ink underline underline-offset-4 hover:text-red">
              info@luizawojtowiczwaga.com
            </a>
          </p>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-8">
          <Accordion type="single" collapsible className="border-t border-ink/15">
            {FAQ.map((f, i) => (
              <AccordionItem key={f.q} value={`item-${i}`} data-testid={`faq-accordion-item-${i}`} className="border-b border-ink/15">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-xl font-medium text-ink hover:no-underline hover:text-red sm:text-2xl [&>svg]:h-5 [&>svg]:w-5 [&>svg]:text-red">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-content-${i}`} className="pb-7 text-[15px] leading-relaxed text-ink/70 sm:text-base">
                  {f.a ?? (
                    <span className="italic text-ink/45">{f.placeholder}</span>
                  )}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
